// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19_NG","type":"styles_type__31LOQ","choices":"styles_choices__2y6Sc"};